<template>
  <div class="homepartner">
    <div class="comp-title ml-2">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Đối tác
        </h1>
      </div>
    </div>
    <div style="clear: both"></div>

    <section class="blue">
      <div class="content">
        <div class="slider responsive">
          <div class="item">
            <h3>
              <img src="../../../../static/img/youtube.png" />
            </h3>
          </div>
          <div class="item">
            <h3>
              <img src="../../../../static/img/zing.png" />
            </h3>
          </div>
          <div class="item">
            <h3>
              <img src="../../../../static/img/nhaccuatui.png" />
            </h3>
          </div>
          <div class="item">
            <h3>
              <img src="../../../../static/img/vinaphone.png" />
            </h3>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Partner",
    components: {
    },
    data () {
      return {

      }
    },
    mounted () {
      $('.responsive').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            // centerMode: true,

          }

        }, {
          breakpoint: 800,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            dots: true,
            infinite: true,

          }


        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            infinite: true,

          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }]
      });
    }
  }
</script>

<style scoped>
  .item img{
    width: 100px;
    height: 40px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/wap/Partner.vue